import { object, string } from 'zod';

export const schema = object({
  token: string().nonempty(),
  password: string().min(8, { message: 'Deve ter no mínimo 8 letras' }).max(32),
});
